import { useTranslation as usePublicI18n } from "react-i18next";
import { publicText, publicTemplate } from "./publicText";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CloseOutlined, MenuOutlined, MailOutlined } from "@ant-design/icons";
import { ReactComponent as Icon } from "../StomataScopeLogo.svg";
function PublicHeader() {
  const { i18n } = usePublicI18n();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const closeMenu = () => setMenuOpen(false);
  const isCaseStudy = location.pathname.startsWith("/case-studies");
  return <header className="public-header">
      <div className="public-header-inner">
        <Link to="/case-studies" className="public-brand" onClick={closeMenu}>
          <Icon className="public-brand-logo" />

          <span>
            <strong>{publicText("Stomata Scope")}</strong>
            <small>{publicText("Plant Physiology Case Studies")}</small>
          </span>
        </Link>

        <nav className={`public-nav ${menuOpen ? "is-open" : ""}`}>
          <Link to="/case-studies" onClick={closeMenu} className={isCaseStudy ? "active" : ""}>{publicText("Case Studies")}</Link>

          <a href="/case-studies#approach" onClick={closeMenu}>{publicText("Research Approach")}</a>

          <a href="https://happy-quality.jp/" target="_blank" rel="noreferrer" onClick={closeMenu}>{publicText("Happy Quality")}</a>

          <a href="https://happy-quality.notion.site/15771c88a48380c39416e9fa1bb2199d" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className="public-contact-button">{publicText("\u6E2C\u5B9A\u30FB\u89E3\u6790\u76F8\u8AC7")}</a>

          <Link to="/login" onClick={closeMenu} className="public-login-button">{publicText("Login")}</Link>
        <div className="public-language-switch" aria-label={publicText("Language")} style={{ display: "flex", gap: 6 }}>
<button type="button" onClick={() => i18n.changeLanguage("ja")} aria-pressed={!(i18n.resolvedLanguage || i18n.language || "ja").startsWith("en")}>日本語</button>
<button type="button" onClick={() => i18n.changeLanguage("en")} aria-pressed={(i18n.resolvedLanguage || i18n.language || "ja").startsWith("en")}>English</button>
</div></nav>

        <button type="button" className="public-mobile-menu-button" onClick={() => setMenuOpen(current => !current)} aria-label={publicText("公開サイトメニュー")} aria-expanded={menuOpen}>
          {publicText(menuOpen ? <CloseOutlined /> : <MenuOutlined />)}
        </button>
      </div>
    </header>;
}
export default PublicHeader;
